module.exports = __webpack_public_path__ + "media/icons/dane-green-2272f52a.svg";